import { SVG } from './SVG';
const IconLinkedInAlt1 = () => {
  return (
    <SVG width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 8.66992C17.5913 8.66992 19.1174 9.30206 20.2426 10.4273C21.3679 11.5525 22 13.0786 22 14.6699V21.6699H18V14.6699C18 14.1395 17.7893 13.6308 17.4142 13.2557C17.0391 12.8806 16.5304 12.6699 16 12.6699C15.4696 12.6699 14.9609 12.8806 14.5858 13.2557C14.2107 13.6308 14 14.1395 14 14.6699V21.6699H10V14.6699C10 13.0786 10.6321 11.5525 11.7574 10.4273C12.8826 9.30206 14.4087 8.66992 16 8.66992Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6 9.66992H2V21.6699H6V9.66992Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M4 6.66992C5.10457 6.66992 6 5.77449 6 4.66992C6 3.56535 5.10457 2.66992 4 2.66992C2.89543 2.66992 2 3.56535 2 4.66992C2 5.77449 2.89543 6.66992 4 6.66992Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVG>
  );
};

export { IconLinkedInAlt1 as default, IconLinkedInAlt1 };
